export default __webpack_public_path__ + "static/media/TaskListMobileApp.6de6110b.PNG";